// Password policy of Cognito pool us-east-1_C0fdh1u5t (checked 2026-10-19):
// at least 8 characters, upper- and lowercase, a number and a symbol.
// Cognito enforces it; this only explains it before the user submits.
export const PASSWORD_RULES = [
  { id: 'length', label: 'At least 8 characters', test: (p) => p.length >= 8 },
  { id: 'case', label: 'Upper- and lowercase letters', test: (p) => /[a-z]/.test(p) && /[A-Z]/.test(p) },
  { id: 'number', label: 'A number', test: (p) => /\d/.test(p) },
  { id: 'symbol', label: 'A symbol (e.g. ! @ # $)', test: (p) => /[^A-Za-z0-9\s]/.test(p) },
];

/** '' when the password can be submitted, otherwise what to tell the user. */
export function passwordProblem(password, confirm) {
  const unmet = PASSWORD_RULES.find((rule) => !rule.test(password));
  if (unmet) return `Your password needs: ${unmet.label.charAt(0).toLowerCase()}${unmet.label.slice(1)}.`;
  if (password !== confirm) return "The two passwords don't match.";
  return '';
}
